module.exports = __webpack_public_path__ + "static/irishEtherealPart-d27bdfe2d4d17e290978a5e48dcae05e.mp3";